require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-five-ways-to-revamp-your-job-search.json") })
        }
      }, "path---blog-five-ways-to-revamp-your-job-search");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-five-ways-to-revamp-your-job-search!./.cache/json/blog-five-ways-to-revamp-your-job-search.json
// module id = 812
// module chunks = 231608221292675